(function () {
  'use strict';

  var observedDrawer = null;
  var drawerObserver = null;

  function hydrateOpenDrawer() {
    var drawer = document.querySelector('.cart__side');
    if (drawer !== observedDrawer) {
      if (drawerObserver) drawerObserver.disconnect();
      observedDrawer = drawer;
      if (drawer && typeof MutationObserver === 'function') {
        drawerObserver = new MutationObserver(hydrateOpenDrawer);
        drawerObserver.observe(drawer, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          subtree: true
        });
      }
    }
    if (!drawer || !drawer.classList.contains('opened')) return;
    drawer.querySelectorAll('img[data-cart-drawer-src]').forEach(function (image) {
      var source = image.getAttribute('data-cart-drawer-src');
      if (!source) return;
      image.setAttribute('src', source);
      image.removeAttribute('data-cart-drawer-src');
    });
  }

  function showUnavailable(image) {
    if (!image || typeof image.matches !== 'function' || !image.matches('img[data-cart-thumbnail]')) return;
    if (image.dataset.cartThumbnailKind !== 'crop' || image.dataset.cartThumbnailFailed) return;
    image.dataset.cartThumbnailFailed = 'true';
    var note = image.getAttribute('data-cart-thumbnail-unavailable') || '';
    var row = image.closest('[data-cart-line-key]');
    var caption = row && row.querySelector('[data-cart-thumbnail-note]');
    if (caption) caption.textContent = note;
    var placeholder = document.createElement('span');
    placeholder.className = 'cart-thumbnail-unavailable';
    placeholder.textContent = note;
    placeholder.setAttribute('role', 'status');
    image.style.setProperty('display', 'none', 'important');
    image.insertAdjacentElement('afterend', placeholder);
  }

  document.addEventListener('error', function (event) { showUnavailable(event.target); }, true);
  document.querySelectorAll('img[data-cart-thumbnail]').forEach(function (image) {
    if (image.getAttribute('src') && image.complete && image.naturalWidth === 0) showUnavailable(image);
  });
  document.addEventListener('stackhouse:cart:updated', hydrateOpenDrawer);
  if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    window.addEventListener('stackhouse:transactional-overlay-state', hydrateOpenDrawer);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateOpenDrawer, { once: true });
  } else {
    hydrateOpenDrawer();
  }
})();
